import React from 'react';
import PropTypes from 'prop-types';

import {
  BrowserRouter as Router,
  Redirect,
  Route as RouterRoute,
  Switch,
} from 'react-router-dom';

import { GlobalStyles } from '@playbookux/playbook-web-core';
import PrivateRoute from '../core/components/private-route';
import Route from '../core/components/route';

import Approvals from './pages/approvals';
import Companies from './pages/companies';
import NLPTraining from './pages/nlp-training';
import Projects from './pages/projects';
import Testers from './pages/testers';
import ManageTesters from './pages/manage-testers';
import EditTester from './pages/edit-tester';
import TesterPersonalForm from './pages/tester-personal-form';
import PracticeTests from './pages/practice-tests';
import PastTesters from './pages/past-testers';
import Audit from './pages/audit';
import Payments from './pages/payments';
import Controls from './pages/controls';
import ModeratedRecordings from './pages/moderated-recordings';
import Pricing from './pages/pricing';
import ProjectDraft from './pages/project-draft';

import ProjectParticipantVideo from '../company/pages/participants-video';
import ProjectParticipantsResponse from '../company/pages/participants-response';
import LinkedInCallback from './pages/linkedin-callback';
import SignIn from '../core/components/sign-in';
import ForgotPassword from '../core/components/forgot-password';
import ResetPassword from '../core/components/reset-password';
import { MaintenancePage } from '../core/pages/maintenance';
import HealthCheck from '../core/components/health-check';

import Tester from './pages/tester';
import Clips from './pages/clips';
import Sessions from './pages/sessions';
import Uploads from './pages/uploads';
import ManageAudience from './pages/manage-audience';

const RoutesAdmin = ({ history }) => (
  <>
    <GlobalStyles />
    <Router history={history}>
      <Switch>
        <Route exact path="/healthcheck" component={HealthCheck} isPublicRoute />

        <Route exact path="/linkedin/callback" component={LinkedInCallback} />
        <Route exact path="/sign-in" component={SignIn} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/reset-password" component={ResetPassword} />
        <Route
          exact
          path="/maintenance"
          component={MaintenancePage}
          isPublicRoute
        />

        <RouterRoute exact path="/" render={() => <Redirect to="/approvals" />} />

        <PrivateRoute exact path="/approvals" component={Approvals} active="approvals" />
        <PrivateRoute exact path="/companies" component={Companies} active="companies" />
        <PrivateRoute exact path="/nlp-training" component={NLPTraining} active="nlp-training" />
        <PrivateRoute exact path="/projects" component={Projects} active="projects" />
        <PrivateRoute exact path="/testers" component={Testers} active="testers" />
        <PrivateRoute exact path="/testers/:id/employment" component={EditTester} active="testers" />
        <PrivateRoute exact path="/testers/:id/personal" component={TesterPersonalForm} active="testers" />
        <PrivateRoute exact path="/manage-testers" component={ManageTesters} active="manage-testers" />

        <PrivateRoute exact path="/tester/:id" component={Tester} active="testers" />
        <PrivateRoute exact path="/practice-tests" component={PracticeTests} active="practice-tests" />
        <PrivateRoute exact path="/past-testers/:companyId" component={PastTesters} />
        <PrivateRoute exact path="/controls" component={Controls} active="controls" />
        <PrivateRoute exact path="/payments" component={Payments} active="payments" />
        <PrivateRoute exact path="/audit" component={Audit} active="audit" />
        <PrivateRoute exact path="/moderated-recordings" component={ModeratedRecordings} active="moderated-recordings" />
        <PrivateRoute exact path="/pricing" component={Pricing} active="pricing" />
        <PrivateRoute exact path="/project-draft/:projectId" component={ProjectDraft} />

        <PrivateRoute exact path="/projects/:projectId/videos/:testerId" component={ProjectParticipantVideo} active="video" />
        <PrivateRoute
          exact
          path="/projects/:projectId/participants-response/:testSessionId"
          component={ProjectParticipantsResponse}
          active="participants-response"
        />
        <PrivateRoute exact path="/clips" component={Clips} active="clips" />
        <PrivateRoute exact path="/sessions" component={Sessions} active="sessions" />
        <PrivateRoute exact path="/uploads" component={Uploads} active="uploads" />
        <PrivateRoute exact path="/manage-audience" component={ManageAudience} active="manage-audience" />

      </Switch>
    </Router>
  </>
);

RoutesAdmin.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default RoutesAdmin;
